import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        faq: window.laravel.faq,
        question: [],
        showAnswer: false,
    },
    mutations: {
        setQuestion: (state, question) => {
            state.question = question;
        },
        setShowAnswer: (state, answer) => {
            state.showAnswer = answer;
        },
    },
    actions: {
        openAnswer: ({state, commit}, question) => {
            commit('setQuestion', question);
            commit('setShowAnswer', true);
        },
        closeAnswer: ({commit}) => {
            commit('setShowAnswer', false);
        },
    },
});

